export default __webpack_public_path__ + "static/media/blog-post-layout-04-img-13.9aa7fb0f.jpg";